export const templateChallengeEntries = String.raw`<!DOCTYPE html>
<html lang="en">
<head>
<meta charset="UTF-8">
<meta name="viewport" content="width=device-width, initial-scale=1.0">
<title>Pasta with 3 ingredients only — Entries — Nemonto</title>
<link rel="preconnect" href="https://fonts.googleapis.com">
<link href="https://fonts.googleapis.com/css2?family=DM+Serif+Display:ital@0;1&family=DM+Sans:ital,wght@0,400;0,500;0,600;0,700;1,400&display=swap" rel="stylesheet">
<style>
  :root{
    --spice:#D85A30; --spice-deep:#B23D18; --cream:#FAECE7; --peach:#F5C4B3;
    --charcoal:#2C2C2A; --herb:#1D9E75; --gold:#FAC775; --muted:#8A7A72;
    --serif:'DM Serif Display', Georgia, serif; --sans:'DM Sans', system-ui, sans-serif;
  }
  *{margin:0;padding:0;box-sizing:border-box;}
  body{background:#F1E4DE; color:var(--charcoal); font-family:var(--sans); font-size:14px; height:100vh; overflow:hidden;}
  a{color:inherit; text-decoration:none;}
  button{font-family:inherit; cursor:pointer; border:none; background:none;}
  :focus-visible{outline:2.5px solid var(--spice); outline-offset:2px; border-radius:4px;}
  ::-webkit-scrollbar{width:7px;}
  ::-webkit-scrollbar-thumb{background:rgba(44,44,42,0.14); border-radius:10px;}
  ::-webkit-scrollbar-track{background:transparent;}

  .app{display:grid; grid-template-columns:264px minmax(0,1fr) 300px; height:100vh; width:100%; max-width:none; margin:0;}

  /* ============ LEFT SIDEBAR ============ */
  .sidebar{padding:26px 18px; display:flex; flex-direction:column; height:100vh; border-right:1px solid rgba(44,44,42,0.07);}
  .brand{display:flex; align-items:center; gap:9px; font-family:var(--serif); font-size:21px; padding:0 10px 28px;}
  .nav-item{display:flex; align-items:center; gap:13px; padding:11px 12px; border-radius:14px; width:100%; font-size:15px; font-weight:500; color:#6B5F58; transition:background .15s, color .15s;}
  .nav-item:hover{background:rgba(44,44,42,0.04);}
  .nav-item.active{background:var(--spice); color:var(--cream);}
  .nav-icon{width:21px; height:21px; flex-shrink:0; display:flex; align-items:center; justify-content:center;}
  .nav-badge{margin-left:auto; background:var(--gold); color:#5A3A00; font-size:10.5px; font-weight:700; padding:2px 7px; border-radius:20px;}
  .nav-item.active .nav-badge{background:rgba(250,236,231,0.25); color:var(--cream);}
  .post-btn{margin:18px 10px 22px; background:var(--spice); color:var(--cream); padding:13px; border-radius:16px; font-size:14.5px; font-weight:700; display:flex; align-items:center; justify-content:center; gap:8px; transition:transform .15s, box-shadow .15s;}
  .post-btn:hover{transform:translateY(-1px); box-shadow:0 10px 22px rgba(216,90,48,0.3);}
  .sidebar-spacer{flex:1;}
  .profile-mini{display:flex; align-items:center; gap:10px; padding:9px 10px; border-radius:14px;}
  .pm-avatar{width:38px; height:38px; border-radius:50%; background:#F0997B; flex-shrink:0;}
  .pm-name{font-size:13.5px; font-weight:600;}
  .pm-handle{font-size:11.5px; color:#9A8C84;}
  .pm-more{margin-left:auto; color:#9A8C84;}

  /* ============ CENTER — ENTRIES ============ */
  .entries-col{height:100vh; overflow-y:auto; border-right:1px solid rgba(44,44,42,0.07);}

  .entries-header{
    position:sticky; top:0; z-index:5; background:rgba(241,228,222,0.94); backdrop-filter:blur(8px);
    padding:18px 28px 0; border-bottom:1px solid rgba(44,44,42,0.06);
  }
  .back-row{display:flex; align-items:center; gap:10px; font-size:13px; color:#9A8C84; font-weight:600; margin-bottom:14px;}
  .eh-top{display:flex; align-items:flex-start; justify-content:space-between; margin-bottom:14px; gap:14px;}
  .eh-title{font-family:var(--serif); font-size:21px; line-height:1.25; margin-bottom:4px;}
  .eh-meta{font-size:12.5px; color:#9A8C84;}

  .judge-toggle-wrap{display:flex; align-items:center; gap:10px; flex-shrink:0; background:#fff; border-radius:30px; padding:6px 6px 6px 14px; border:1px solid rgba(44,44,42,0.08);}
  .judge-toggle-text{font-size:12.5px; font-weight:600; color:var(--charcoal);}
  .toggle-switch{width:42px; height:24px; border-radius:14px; background:rgba(44,44,42,0.15); position:relative; flex-shrink:0; transition:background .2s;}
  .toggle-switch.on{background:var(--spice);}
  .toggle-knob{position:absolute; top:3px; left:3px; width:18px; height:18px; border-radius:50%; background:#fff; transition:transform .2s; box-shadow:0 1px 3px rgba(0,0,0,0.2);}
  .toggle-switch.on .toggle-knob{transform:translateX(18px);}

  .judging-banner{
    background:var(--charcoal); color:var(--cream); border-radius:14px; padding:11px 16px; font-size:12.5px;
    margin-bottom:14px; display:none; align-items:center; gap:9px; line-height:1.5;
  }
  .judging-banner.show{display:flex;}
  .judging-banner b{color:var(--gold);}

  .filter-row{display:flex; gap:7px; padding-bottom:14px; flex-wrap:wrap;}
  .filter-pill{font-size:12px; font-weight:600; padding:7px 13px; border-radius:20px; background:#fff; border:1px solid rgba(44,44,42,0.1); color:#6B5F58;}
  .filter-pill.active{background:var(--spice); color:#fff; border-color:var(--spice);}

  .entries-body{padding:18px 28px 60px; max-width:none;}

  .entry-card{background:#fff; border-radius:20px; padding:16px; margin-bottom:16px; border:1px solid rgba(44,44,42,0.06); transition:box-shadow .2s;}
  .entry-card.winner-selected{border:2px solid var(--gold); background:rgba(250,199,117,0.05);}
  .ec-top{display:flex; align-items:center; gap:10px; margin-bottom:11px;}
  .ec-avatar{width:38px; height:38px; border-radius:50%; flex-shrink:0;}
  .ec-name{font-size:13.5px; font-weight:600; display:flex; align-items:center; gap:5px;}
  .ec-time{font-size:11.5px; color:#9A8C84;}
  .ec-reaction{margin-left:auto; font-size:10.5px; font-weight:700; padding:4px 10px; border-radius:20px;}
  .ec-reaction.nailed{background:#E1F5EE; color:#085041;}
  .ec-reaction.twist{background:#FAEEDA; color:#633806;}
  .ec-reaction.almost{background:#F1E4DE; color:#6B5F58;}

  .ec-media{height:160px; border-radius:14px; margin-bottom:11px; display:flex; align-items:center; justify-content:center; position:relative;}
  .ec-play{position:absolute; bottom:10px; right:10px; width:34px; height:34px; border-radius:50%; background:rgba(255,255,255,0.92); display:flex; align-items:center; justify-content:center; color:var(--spice-deep);}

  .ec-text{font-size:13.5px; color:#3A3330; line-height:1.55; margin-bottom:12px;}
  .ec-cook-time{display:inline-flex; align-items:center; gap:5px; font-size:11.5px; color:#9A8C84; background:#F8EFEB; padding:4px 10px; border-radius:20px; margin-bottom:12px;}

  .ec-actions{display:flex; align-items:center; gap:16px; padding-top:11px; border-top:1px solid rgba(44,44,42,0.06);}
  .ec-action{display:flex; align-items:center; gap:6px; font-size:12.5px; color:#6B5F58; font-weight:500;}
  .ec-action.liked{color:var(--spice-deep);}

  .crown-btn{
    margin-left:auto; display:none; align-items:center; gap:7px; background:#fff; color:var(--spice-deep); font-size:12.5px;
    font-weight:700; padding:9px 16px; border-radius:30px; border:1.5px solid var(--spice); transition:background .15s, color .15s;
  }
  .crown-btn:hover{background:var(--spice); color:#fff;}
  .judging-on .crown-btn{display:flex;}
  .winner-selected .crown-btn{display:flex; background:var(--gold); color:#5A3A00; border-color:var(--gold);}
  .winner-selected .crown-btn:hover{background:var(--gold); color:#5A3A00;}

  .winner-flag{
    display:none; align-items:center; gap:7px; background:rgba(250,199,117,0.18); color:#8A5A00; font-size:11.5px;
    font-weight:700; padding:7px 13px; border-radius:20px; margin-bottom:12px;
  }
  .winner-selected .winner-flag{display:flex;}

  /* ============ MODAL ============ */
  .modal-overlay{
    position:fixed; inset:0; background:rgba(44,44,42,0.5); backdrop-filter:blur(2px); display:none;
    align-items:center; justify-content:center; z-index:100;
  }
  .modal-overlay.show{display:flex;}
  .modal-card{background:#fff; border-radius:24px; padding:28px; max-width:380px; width:90%; text-align:center; box-shadow:0 30px 60px -10px rgba(44,28,18,0.3);}
  .modal-bowl{margin:0 auto 16px;}
  .modal-title{font-family:var(--serif); font-size:21px; margin-bottom:14px;}
  .modal-entrant{display:flex; align-items:center; gap:10px; background:#F8EFEB; border-radius:14px; padding:12px; margin-bottom:14px; text-align:left;}
  .modal-entrant-avatar{width:36px; height:36px; border-radius:50%; flex-shrink:0;}
  .modal-entrant b{font-size:13px; display:block;}
  .modal-entrant span{font-size:11.5px; color:#9A8C84;}
  .modal-quote{font-size:13px; font-style:italic; color:#6B5F58; line-height:1.5; margin-bottom:20px;}
  .modal-confirm{width:100%; background:var(--spice); color:#fff; font-size:14px; font-weight:700; padding:13px 0; border-radius:30px; margin-bottom:10px; transition:transform .15s, box-shadow .15s;}
  .modal-confirm:hover{transform:translateY(-1px); box-shadow:0 10px 22px rgba(216,90,48,0.3);}
  .modal-cancel{width:100%; color:#9A8C84; font-size:13px; font-weight:600; padding:10px 0;}

  /* ============ RIGHT RAIL ============ */
  .right-rail{height:100vh; overflow-y:auto; padding:24px 20px 40px;}
  .rail-block{margin-bottom:26px;}
  .rail-head{margin-bottom:14px;}
  .rail-head h3{font-size:13px; font-weight:700; text-transform:uppercase; letter-spacing:0.04em; color:#6B5F58;}

  .challenge-mini{background:var(--charcoal); border-radius:18px; padding:18px; position:relative; overflow:hidden;}
  .challenge-mini::before{content:''; position:absolute; top:-50px; right:-40px; width:120px; height:120px; background:radial-gradient(circle, rgba(216,90,48,0.4), transparent 70%);}
  .cm-live{display:inline-flex; align-items:center; gap:5px; background:var(--spice); color:#fff; font-size:10px; font-weight:700; padding:4px 9px; border-radius:20px; margin-bottom:10px; position:relative;}
  .cm-live .dot{width:5px; height:5px; border-radius:50%; background:#fff; animation:pulse 1.8s infinite;}
  @keyframes pulse{0%,100%{opacity:1;}50%{opacity:0.3;}}
  .cm-title{font-family:var(--serif); font-size:15px; color:var(--cream); margin-bottom:12px; line-height:1.3; position:relative;}
  .cm-stats{display:flex; gap:8px; position:relative;}
  .cm-stat{flex:1; background:rgba(250,236,231,0.07); border-radius:10px; padding:9px; text-align:center;}
  .cm-stat b{display:block; font-size:15px; color:var(--gold); font-family:var(--serif);}
  .cm-stat span{font-size:9.5px; color:rgba(250,236,231,0.55);}

  .ingredient-recap{display:flex; gap:6px; flex-wrap:wrap; margin-top:14px; position:relative;}
  .ingredient-recap span{background:rgba(250,236,231,0.1); color:var(--cream); font-size:10.5px; padding:4px 9px; border-radius:20px;}

  .progress-card{background:#fff; border-radius:16px; padding:16px; border:1px solid rgba(44,44,42,0.06);}
  .progress-label{font-size:12px; color:#6B5F58; margin-bottom:10px; line-height:1.5;}
  .progress-bar-wrap{height:6px; background:rgba(44,44,42,0.08); border-radius:4px; overflow:hidden; margin-bottom:6px;}
  .progress-bar{width:35%; height:100%; background:var(--spice); border-radius:4px;}
  .progress-sub{font-size:11px; color:#9A8C84;}

  .reaction-breakdown{background:#fff; border-radius:16px; padding:16px; border:1px solid rgba(44,44,42,0.06);}
  .rb-row{display:flex; align-items:center; gap:10px; margin-bottom:10px;}
  .rb-row:last-child{margin-bottom:0;}
  .rb-label{font-size:12px; color:#6B5F58; width:84px; flex-shrink:0;}
  .rb-bar-wrap{flex:1; height:8px; background:rgba(44,44,42,0.06); border-radius:4px; overflow:hidden;}
  .rb-bar{height:100%; border-radius:4px;}
  .rb-count{font-size:12px; font-weight:600; color:var(--charcoal); width:24px; text-align:right;}

  @media (max-width:1180px){
    .app{grid-template-columns:84px minmax(0,1fr) 300px;}
    .brand span.brand-text, .nav-item span.nav-label, .post-btn span.btn-label, .pm-name, .pm-handle{display:none;}
    .nav-item{justify-content:center;} .nav-badge{display:none;} .post-btn{padding:13px;} .profile-mini{justify-content:center;}
  }
  @media (max-width:900px){
    .app{grid-template-columns:84px minmax(0,1fr);}
    .right-rail{display:none;}
  }
</style>
</head>
<body>

<div class="app">

  <!-- ================= LEFT SIDEBAR ================= -->
  <aside class="sidebar">
    <div class="brand">
      <img src="../image/nemonto-logo.png" alt="Nemonto" style="height:32px; width:auto; display:block;" />
    </div>
    <nav>
      <a class="nav-item" href="#">
        <span class="nav-icon"><svg width="20" height="20" viewBox="0 0 24 24" fill="none"><path d="M4 11l8-7 8 7M6 10v9a1 1 0 001 1h4v-6h2v6h4a1 1 0 001-1v-9" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg></span>
        <span class="nav-label">Home</span>
      </a>
      <a class="nav-item" href="#">
        <span class="nav-icon"><svg width="20" height="20" viewBox="0 0 24 24" fill="none"><circle cx="11" cy="11" r="7" stroke="currentColor" stroke-width="1.8"/><path d="M20 20l-3.5-3.5" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg></span>
        <span class="nav-label">Explore</span>
      </a>
      <a class="nav-item" href="#">
        <span class="nav-icon"><svg width="20" height="20" viewBox="0 0 24 24" fill="none"><path d="M4 4h16v12H7l-3 3V4z" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/></svg></span>
        <span class="nav-label">Made it</span>
      </a>
      <a class="nav-item active" href="#">
        <span class="nav-icon"><svg width="20" height="20" viewBox="0 0 24 24" fill="none"><path d="M4 21V5a1 1 0 011-1h14a1 1 0 011 1v16l-8-4-8 4z" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/></svg></span>
        <span class="nav-label">Challenges</span>
        <span class="nav-badge">3 live</span>
      </a>
      <a class="nav-item" href="#">
        <span class="nav-icon"><svg width="20" height="20" viewBox="0 0 24 24" fill="none"><path d="M20.8 4.6c-1.5-1.5-4-1.5-5.6.1L12 7.9 8.8 4.7c-1.6-1.6-4.1-1.6-5.6-.1-1.5 1.5-1.5 4 .1 5.6L12 19l8.7-8.8c1.6-1.6 1.6-4.1.1-5.6z" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/></svg></span>
        <span class="nav-label">Saved</span>
      </a>
      <a class="nav-item" href="#">
        <span class="nav-icon"><svg width="20" height="20" viewBox="0 0 24 24" fill="none"><path d="M21 11.5a8.4 8.4 0 01-1.2 4.4L21 20l-4.3-1.2a8.5 8.5 0 11-1.8-15.6 8.5 8.5 0 016.1 7.3z" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/></svg></span>
        <span class="nav-label">Messages</span>
        <span class="nav-badge">2</span>
      </a>
      <a class="nav-item" href="#">
        <span class="nav-icon"><svg width="20" height="20" viewBox="0 0 24 24" fill="none"><circle cx="9" cy="8" r="3.4" stroke="currentColor" stroke-width="1.6"/><path d="M3 19c0-3 2.5-5 6-5s6 2 6 5" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg></span>
        <span class="nav-label">Profile</span>
      </a>
    </nav>
    <div class="post-btn">
      <svg width="17" height="17" viewBox="0 0 20 20" fill="none"><path d="M10 4v12M4 10h12" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>
      <span class="btn-label">New recipe</span>
    </div>
    <div class="sidebar-spacer"></div>
    <div class="profile-mini">
      <div class="pm-avatar"></div>
      <div><div class="pm-name">Maria K.</div><div class="pm-handle">@mariakcooks</div></div>
      <span class="pm-more">⋯</span>
    </div>
  </aside>

  <!-- ================= CENTER — ENTRIES ================= -->
  <main class="entries-col" id="entriesCol">

    <div class="entries-header">
      <div class="back-row">
        <svg width="16" height="16" viewBox="0 0 16 16"><path d="M10 13L5 8l5-5" stroke="#9A8C84" stroke-width="1.6" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg>
        Back to your challenges
      </div>

      <div class="eh-top">
        <div>
          <p class="eh-title">Pasta with 3 ingredients only</p>
          <p class="eh-meta">84 entries · 47h 22m remaining</p>
        </div>
        <div class="judge-toggle-wrap">
          <span class="judge-toggle-text">Judging mode</span>
          <div class="toggle-switch" id="judgeToggle"><div class="toggle-knob"></div></div>
        </div>
      </div>

      <div class="judging-banner" id="judgingBanner">
        <span>🏅</span>
        <span>Judging mode is on — tap <b>Crown winner</b> on the entry you want to select. You can only pick one.</span>
      </div>

      <div class="filter-row">
        <span class="filter-pill active" data-filter="all">All entries · 84</span>
        <span class="filter-pill" data-filter="nailed">🔥 Nailed it · 51</span>
        <span class="filter-pill" data-filter="twist">🔄 My twist · 19</span>
        <span class="filter-pill" data-filter="almost">😅 Almost · 14</span>
      </div>
    </div>

    <div class="entries-body" id="entriesBody">

      <!-- ENTRY 1 -->
      <div class="entry-card" data-reaction="nailed">
        <div class="winner-flag">🏆 You crowned this entry the winner</div>
        <div class="ec-top">
          <div class="ec-avatar" style="background:#9FE1CB;"></div>
          <div><div class="ec-name">Priya R. 🏅</div><div class="ec-time">2 hours ago</div></div>
          <span class="ec-reaction nailed">🔥 Nailed it</span>
        </div>
        <div class="ec-media" style="background:linear-gradient(150deg,#6FCBA4,#0D6B4E);">
          <svg width="38" height="38" viewBox="0 0 100 100"><circle cx="38" cy="44" r="10" fill="#fff" opacity="0.9"/><circle cx="58" cy="40" r="8" fill="#fff" opacity="0.7"/></svg>
          <div class="ec-play"><svg width="14" height="14" viewBox="0 0 16 16"><path d="M4 2l10 6-10 6V2z" fill="currentColor"/></svg></div>
        </div>
        <span class="ec-cook-time">⏱ 12 min</span>
        <p class="ec-text">Used the pasta water trick exactly like you said — went from grainy to silky the second time around.</p>
        <div class="ec-actions">
          <span class="ec-action liked">♥ 241</span>
          <span class="ec-action">💬 18</span>
          <button class="crown-btn" data-name="Priya R." data-quote="Used the pasta water trick exactly like you said — went from grainy to silky the second time around." data-avatar="#9FE1CB" data-reaction="🔥 Nailed it">🏆 Crown winner</button>
        </div>
      </div>

      <!-- ENTRY 2 -->
      <div class="entry-card" data-reaction="twist">
        <div class="winner-flag">🏆 You crowned this entry the winner</div>
        <div class="ec-top">
          <div class="ec-avatar" style="background:#AFA9EC;"></div>
          <div><div class="ec-name">James L.</div><div class="ec-time">4 hours ago</div></div>
          <span class="ec-reaction twist">🔄 My twist</span>
        </div>
        <div class="ec-media" style="background:linear-gradient(150deg,#9890DF,#534AB7);">
          <svg width="38" height="38" viewBox="0 0 100 100"><rect x="22" y="34" width="56" height="42" rx="8" fill="#fff" opacity="0.6"/></svg>
          <div class="ec-play"><svg width="14" height="14" viewBox="0 0 16 16"><path d="M4 2l10 6-10 6V2z" fill="currentColor"/></svg></div>
        </div>
        <span class="ec-cook-time">⏱ 18 min</span>
        <p class="ec-text">Added a little lemon zest at the end — cuts through the richness nicely. Still very much your recipe though.</p>
        <div class="ec-actions">
          <span class="ec-action">♥ 87</span>
          <span class="ec-action">💬 9</span>
          <button class="crown-btn" data-name="James L." data-quote="Added a little lemon zest at the end — cuts through the richness nicely." data-avatar="#AFA9EC" data-reaction="🔄 My twist">🏆 Crown winner</button>
        </div>
      </div>

      <!-- ENTRY 3 -->
      <div class="entry-card" data-reaction="nailed">
        <div class="winner-flag">🏆 You crowned this entry the winner</div>
        <div class="ec-top">
          <div class="ec-avatar" style="background:#F5C4B3;"></div>
          <div><div class="ec-name">Chen W.</div><div class="ec-time">6 hours ago</div></div>
          <span class="ec-reaction nailed">🔥 Nailed it</span>
        </div>
        <div class="ec-media" style="background:linear-gradient(150deg,#E8693D,#993C1D);">
          <svg width="38" height="38" viewBox="0 0 100 100"><circle cx="50" cy="50" r="22" fill="#fff" opacity="0.6"/></svg>
          <div class="ec-play"><svg width="14" height="14" viewBox="0 0 16 16"><path d="M4 2l10 6-10 6V2z" fill="currentColor"/></svg></div>
        </div>
        <span class="ec-cook-time">⏱ 15 min</span>
        <p class="ec-text">Didn't expect 3 ingredients to taste this good. My kitchen smells like a trattoria right now.</p>
        <div class="ec-actions">
          <span class="ec-action liked">♥ 64</span>
          <span class="ec-action">💬 5</span>
          <button class="crown-btn" data-name="Chen W." data-quote="Didn't expect 3 ingredients to taste this good." data-avatar="#F5C4B3" data-reaction="🔥 Nailed it">🏆 Crown winner</button>
        </div>
      </div>

      <!-- ENTRY 4 -->
      <div class="entry-card" data-reaction="almost">
        <div class="winner-flag">🏆 You crowned this entry the winner</div>
        <div class="ec-top">
          <div class="ec-avatar" style="background:#FAC775;"></div>
          <div><div class="ec-name">Sofia M. 🏅</div><div class="ec-time">Yesterday</div></div>
          <span class="ec-reaction almost">😅 Almost</span>
        </div>
        <p class="ec-text">First attempt clumped on me but I think I added the cheese too fast. Trying again tomorrow with the slow whisk tip.</p>
        <div class="ec-actions">
          <span class="ec-action">♥ 19</span>
          <span class="ec-action">💬 3</span>
          <button class="crown-btn" data-name="Sofia M." data-quote="First attempt clumped on me but trying again tomorrow." data-avatar="#FAC775" data-reaction="😅 Almost">🏆 Crown winner</button>
        </div>
      </div>

    </div>
  </main>

  <!-- ================= RIGHT RAIL ================= -->
  <aside class="right-rail">

    <div class="rail-block">
      <div class="challenge-mini">
        <span class="cm-live"><span class="dot"></span>LIVE NOW</span>
        <p class="cm-title">Pasta with 3 ingredients only</p>
        <div class="cm-stats">
          <div class="cm-stat"><b>84</b><span>entries</span></div>
          <div class="cm-stat"><b>30m</b><span>max cook</span></div>
          <div class="cm-stat"><b>47h</b><span>remaining</span></div>
        </div>
        <div class="ingredient-recap">
          <span>🍝 Pasta</span><span>🥚 Eggs</span><span>🧀 Pecorino</span>
        </div>
      </div>
    </div>

    <div class="rail-block">
      <div class="rail-head"><h3>Review progress</h3></div>
      <div class="progress-card">
        <p class="progress-label">You've reviewed <b>29 of 84</b> entries so far. Take your time — entries stay open until the timer ends.</p>
        <div class="progress-bar-wrap"><div class="progress-bar"></div></div>
        <p class="progress-sub">35% reviewed</p>
      </div>
    </div>

    <div class="rail-block">
      <div class="rail-head"><h3>Reaction breakdown</h3></div>
      <div class="reaction-breakdown">
        <div class="rb-row">
          <span class="rb-label">🔥 Nailed it</span>
          <div class="rb-bar-wrap"><div class="rb-bar" style="width:61%; background:#1D9E75;"></div></div>
          <span class="rb-count">51</span>
        </div>
        <div class="rb-row">
          <span class="rb-label">🔄 My twist</span>
          <div class="rb-bar-wrap"><div class="rb-bar" style="width:23%; background:#EF9F27;"></div></div>
          <span class="rb-count">19</span>
        </div>
        <div class="rb-row">
          <span class="rb-label">😅 Almost</span>
          <div class="rb-bar-wrap"><div class="rb-bar" style="width:17%; background:#9A8C84;"></div></div>
          <span class="rb-count">14</span>
        </div>
      </div>
    </div>

  </aside>

</div>

<!-- ================= WINNER CONFIRMATION MODAL ================= -->
<div class="modal-overlay" id="modalOverlay">
  <div class="modal-card">
    <svg class="modal-bowl" width="48" height="48" viewBox="0 0 100 100">
      <ellipse cx="50" cy="74" rx="30" ry="6" fill="#993C1D" opacity="0.5"/>
      <path d="M20 50 Q20 78 50 78 Q80 78 80 50 Z" fill="#D85A30"/>
      <path d="M18 47 Q18 53 23 53 L77 53 Q82 53 82 47 Q82 38 50 38 Q18 38 18 47 Z" fill="#FAECE7"/>
      <path d="M34 30 Q31 22 34 13" stroke="#FAC775" stroke-width="3.5" fill="none" stroke-linecap="round"/>
      <path d="M50 27 Q47 19 50 10" stroke="#FAC775" stroke-width="3.5" fill="none" stroke-linecap="round"/>
      <path d="M66 30 Q63 22 66 13" stroke="#FAC775" stroke-width="3.5" fill="none" stroke-linecap="round"/>
    </svg>
    <p class="modal-title">Crown this winner?</p>
    <div class="modal-entrant">
      <div class="modal-entrant-avatar" id="modalAvatar"></div>
      <div><b id="modalName"></b><span id="modalReaction"></span></div>
    </div>
    <p class="modal-quote" id="modalQuote"></p>
    <button class="modal-confirm" id="modalConfirmBtn">Yes, crown them 🏆</button>
    <button class="modal-cancel" id="modalCancelBtn">Keep looking</button>
  </div>
</div>

<script>
  const judgeToggle = document.getElementById('judgeToggle');
  const entriesCol = document.getElementById('entriesCol');
  const judgingBanner = document.getElementById('judgingBanner');

  judgeToggle.addEventListener('click', () => {
    const on = judgeToggle.classList.toggle('on');
    entriesCol.classList.toggle('judging-on', on);
    judgingBanner.classList.toggle('show', on);
  });

  document.querySelectorAll('.filter-pill').forEach(pill => {
    pill.addEventListener('click', () => {
      document.querySelectorAll('.filter-pill').forEach(p => p.classList.remove('active'));
      pill.classList.add('active');
      const filter = pill.dataset.filter;
      document.querySelectorAll('.entry-card').forEach(card => {
        card.style.display = (filter === 'all' || card.dataset.reaction === filter) ? 'block' : 'none';
      });
    });
  });

  const modalOverlay = document.getElementById('modalOverlay');
  const modalAvatar = document.getElementById('modalAvatar');
  const modalName = document.getElementById('modalName');
  const modalReaction = document.getElementById('modalReaction');
  const modalQuote = document.getElementById('modalQuote');
  const modalConfirmBtn = document.getElementById('modalConfirmBtn');
  const modalCancelBtn = document.getElementById('modalCancelBtn');
  let pendingCard = null;

  document.querySelectorAll('.crown-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      pendingCard = btn.closest('.entry-card');
      modalAvatar.style.background = btn.dataset.avatar;
      modalName.textContent = btn.dataset.name;
      modalReaction.textContent = btn.dataset.reaction;
      modalQuote.textContent = '"' + btn.dataset.quote + '"';
      modalOverlay.classList.add('show');
    });
  });

  modalCancelBtn.addEventListener('click', () => modalOverlay.classList.remove('show'));
  modalOverlay.addEventListener('click', (e) => { if(e.target === modalOverlay) modalOverlay.classList.remove('show'); });

  modalConfirmBtn.addEventListener('click', () => {
    document.querySelectorAll('.entry-card').forEach(c => c.classList.remove('winner-selected'));
    if(pendingCard) pendingCard.classList.add('winner-selected');
    modalOverlay.classList.remove('show');
    if(pendingCard) pendingCard.scrollIntoView({behavior:'smooth', block:'center'});
  });
</script>

</body>
</html>

`;
